import React from "react";
import Form from "../../../Reusable/Form/Form.js";
import config from "config";
import Button from "../../../Elements/Button/Button.js";
import SecurityPasswordField from "components/Reusable/Form/Reusable/SecurityPasswordField.tsx";
import SettingsItem from "components/Reusable/Form/Reusable/SettingField.tsx";
import DownloadLimit from "components/Reusable/Form/Reusable/DownloadLimitField.tsx";
import CollaborationMailField from "components/Reusable/Form/Reusable/CollaborationMailField.tsx";
import { useContent } from "../../../../contexts/contentContext/contentContext.js";
import { useUser } from "../../../../contexts/userContext/userContext.js";
import { useModal } from "../../../../contexts/modalContext/modalContext.js";
import useInbox from "hooks/useInbox.ts";
import { useMail } from "../../../../contexts/mailContext/mailContext.js";
import { useSideBar } from "contexts/sideBarContext/sideBarContext.js";
import { useToasts } from "react-toast-notifications";

const securityOptionsFields = {
  SecurityPass: {
    element: "customelement",
    fieldKey: "SecurityPass",
    type: "password",
    render: (props) => (
      <SecurityPasswordField
        icon="lock-light"
        subcribersOnly={true}
        {...props}
      />
    ),
  },
  BlockShare: {
    element: "customelement",
    fieldKey: "BlockShare",
    render: (props) => (
      <SettingsItem
        textKey="block-share-text"
        tooltip="enabled-due-to-collaboration"
        disableOption={{
          fieldName: "Collaboration",
          conditionFunc: (value) => value === "recipients",
          tooltipOnDisable: true,
          turnOnDisable: true,
        }}
        icon="social"
        {...props}
      />
    ),
  },
  DownloadLimit: {
    element: "customelement",
    fieldKey: "DownloadLimit",
    render: (props) => (
      <DownloadLimit icon="downloads" subcribersOnly={true} {...props} />
    ),
  },
  RecipientAccess: {
    element: "customelement",
    fieldKey: "RecipientAccess",
    render: (props) => (
      <SettingsItem
        textKey="recipient-access-text"
        icon="recipient"
        subcribersOnly={true}
        tooltip="recipient-access-only-tooltip"
        {...props}
      />
    ),
  },
  PreviewAccess: {
    element: "customelement",
    fieldKey: "PreviewAccess",
    render: (props) => (
      <SettingsItem
        textKey="preview-access-text"
        icon="eye-light"
        subcribersOnly={true}
        tooltip="preview-access-only-tooltip"
        {...props}
      />
    ),
  },
  Collaboration: {
    element: "customelement",
    fieldKey: "Collaboration",
    render: (props) => <CollaborationMailField {...props} />,
  },
};

const SecuritySettings = ({ data, isSideBar }) => {
  const { getTextByKey, getPath } = useContent();
  const { isSubscribed } = useUser();
  const { setSecurity } = useMail();
  const { closeSlideBar } = useSideBar();
  const { addToast } = useToasts();

  const { closeModal } = useModal();
  const { updateMailSecuritySettings } = useInbox();

  const handleSubmit = async (body) => {
    const res = await updateMailSecuritySettings(
      body,
      data.id,
      closeModal,
      setSecurity
    );
    if (res.status === "success") {
      addToast(getTextByKey("security-settings-updated"), {
        appearance: "success",
      });
      if (isSideBar) {
        closeSlideBar();
      } else {
        closeModal();
      }
    }
  };

  const redirectToSubscribersPage = () => {
    window.open(`${config.baseurl}${getPath()}subscribers`, "_blank");
    closeModal();
  };

  return isSubscribed() ? (
    <div className={`security-settings-modal${isSideBar ? " sidebar" : ""}`}>
      <div className="security-title">
        {getTextByKey("security-settings-modal-title")}
      </div>
      <div className="security-settings-content">
        <Form
          fieldsProps={{ label: "hidden", field: "square" }}
          buttonProps={{ buttonsSize: "large" }}
          fields={securityOptionsFields}
          onSubmit={handleSubmit}
          submitProps={{
            title: getTextByKey("update-settings-text"),
            className: "payment-settings-submit-button",
          }}
          defaultValuesObj={
            data.security
              ? {
                  SecurityPass: data.security.password,
                  DownloadLimit: data.security.downloadLimit,
                  BlockShare: data.security.isSharingDisabled,
                  RecipientAccess: data.security.recipientsOnly,
                  PreviewAccess: data.security.previewFiles,
                  Collaboration: data.security.collaboration,
                }
              : {}
          }
          // captchaProvider="cloudflare"
          // cloudflareActionName="updateMailSecuritySettings"
        ></Form>
      </div>
    </div>
  ) : (
    <div className="security-settings-modal">
      <div className="security-access-forbidden-title">
        {getTextByKey("security-settings-access-forbidden-title")}
      </div>
      <div className="security-settings-forbidden-content">
        <p className="security-settings-access-forbidden-text">
          {getTextByKey("security-settings-access-forbidden-text")}
        </p>
        <Button
          title={getTextByKey("redirect-to-subscribers-button-text")}
          onClick={redirectToSubscribersPage}
        />
      </div>
    </div>
  );
};

export default SecuritySettings;
